export const SUPPORT_GROUP_OPENSUPPORTGROUP_BEGIN =
  'SUPPORT_GROUP_OPENSUPPORTGROUP_BEGIN';
export const SUPPORT_GROUP_OPENSUPPORTGROUP_SUCCESS =
  'SUPPORT_GROUP_OPENSUPPORTGROUP_SUCCESS';
export const SUPPORT_GROUP_OPENSUPPORTGROUP_FAILURE =
  'SUPPORT_GROUP_OPENSUPPORTGROUP_FAILURE';
export const SUPPORT_GROUP_OPENSUPPORTGROUP_DISMISS_ERROR =
  'SUPPORT_GROUP_OPENSUPPORTGROUP_DISMISS_ERROR';
